import { render, staticRenderFns } from "./createMaterialForm.vue?vue&type=template&id=15a37a46&scoped=true&"
import script from "./createMaterialForm.vue?vue&type=script&lang=js&"
export * from "./createMaterialForm.vue?vue&type=script&lang=js&"
import style0 from "./createMaterialForm.vue?vue&type=style&index=0&id=15a37a46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a37a46",
  null
  
)

export default component.exports